import React, { Fragment } from 'react'
import { compose } from 'redux'
import withFormResponseHandler from '../withFormResponseHandler'
import classnames from 'classnames'
import {
  makeForm,
  TextFormField,
  MaskedFormField,
  BaseComponent,
  SelectDropdownFormField,
} from 'belle-js'
import styles from '../FormStyles.module.scss'
import {
  INCOME_TAX_DATE,
  DATE,
  YEAR
} from 'utils/fieldMasking'
import {
  SCHWAB_IRA,
} from 'utils/financialAccountTypes.js'
import { typesOfBusiness } from 'utils/employerOptions'
import {
  firstNameValidation,
  postalCodeValidation,
  cityValidation,
  stateValidation,
  employerIdNumberValidation,
  employerIncomeTaxDate,
  phoneNumberValidation,
  dateValidation,
  yearValidation,
  employerPlanNameValidation,
} from 'utils/fieldValidations'
import {
  effectiveDateYearOnly,
  normalizeEffectiveDate
} from 'utils/financialAccounts'

class EmployerInformationForm extends BaseComponent {

  constructor (props) {
    super(props)
    this.bind(
      'renderIncomeTax',
      'renderExistingEffectiveDate',
    )
  }

  renderIncomeTax () {
    const { data } = this.props

    if (!data) return ''

    const {
      employerFiscalYearEndMonth,
      employerFiscalYearEndDay
    } = data

    const incomeTaxDate = (
      employerFiscalYearEndMonth && employerFiscalYearEndDay
    ) ? `${employerFiscalYearEndMonth}/${employerFiscalYearEndDay}` :
      ''

    return incomeTaxDate
  }

  renderExistingEffectiveDate () {
    const {
      data: {
        employerPlanEffectiveDate,
        subType
      }
    } = this.props

    if (subType === SCHWAB_IRA.ACCOUNT_TYPES.SIMPLE_IRA) {
      if (employerPlanEffectiveDate &&
            employerPlanEffectiveDate.indexOf('-') > -1) {
        return employerPlanEffectiveDate.split('-')[0]
      }
    }

    return normalizeEffectiveDate(employerPlanEffectiveDate)
  }

  getEffectiveDateYearOnly () {
    const {
      data:{
        subType,
        employerEffectiveDateConfiguration
      }
    } = this.props

    return effectiveDateYearOnly(subType, employerEffectiveDateConfiguration)
  }


  render () {
    const {
      data,
      formValid,
      onClick,
      isMobile,
      subType
    } = this.props

    const mobileZipStyles = classnames(
      styles.FormFieldInSection,
      styles.mobileZipInput
    )

    const primaryButtonClasses = classnames(
      'button',
      'button--primary',
      styles.submitButton,
      !formValid ? 'disabled' : null
    )

    const effectiveDatesColumns = classnames(
      styles.flex,
      styles.twoColumn
    )

    const isAmendment = (data.employerEffectiveDateConfiguration ===
     SCHWAB_IRA.EFFECTIVE_DATE_CONFIG.AMENDMENT_AND_RESTATEMENT)
    const isIndividual401k = subType === SCHWAB_IRA.ACCOUNT_TYPES.INDIVIDUAL_401K

    return (
      <div className={styles.Form}>
        <div className={styles.customFormSection}>
          <div className={styles.formInput}>
            <p className={styles.heading}>name of employer</p>
            <TextFormField
              name="employerName"
              label="Name"
              className={styles.FormFieldInSection}
              placeholder="Employer name"
              maxLength={35}
              value={data.employerName || ''}
              validations={firstNameValidation.rules}
              validationErrors={firstNameValidation.messages}
              testId="employerInformationForm__employerName__field" />
          </div>
        </div>

        <div className={styles.smallCustomFormSection}>
          <div className={styles.formInput}>
            <p className={styles.heading}>Business Address</p>

            <div className={styles.twoColumn}>
              <div className={styles.businessAddress}>
                <div>
                  <TextFormField
                    name="employerStreetAddress"
                    label="Street Address"
                    className={styles.FormFieldInSection}
                    placeholder="Street name and number"
                    maxLength={35}
                    value={data.employerStreetAddress || ''}
                    testId="employerInformationForm__employerStreetAddress__field" />
                  {!isMobile &&
                  <TextFormField
                    name="employerCity"
                    label="City"
                    className={styles.FormFieldInSection}
                    placeholder="City"
                    maxLength={35}
                    value={data.employerCity || ''}
                    validations={cityValidation.rules}
                    validationErrors={cityValidation.messages}
                    testId="employerInformationForm__employerCity__field" />
                  }
                  {!isMobile &&
                  <TextFormField
                    name="employerPostalCode"
                    label="Zipcode"
                    className={styles.FormFieldInSection}
                    placeholder="Zipcode"
                    maxLength={20}
                    value={data.employerPostalCode || ''}
                    validations={postalCodeValidation.rules}
                    validationErrors={postalCodeValidation.messages}
                    testId="employerInformationForm__employerPostalCode__field" />
                  }
                </div>

                <div>
                  {isMobile &&
                  <TextFormField
                    name="employerCity"
                    label="city"
                    className={styles.FormFieldInSection}
                    placeholder="city"
                    maxLength={35}
                    value={data.employerCity || ''}
                    validations={cityValidation.rules}
                    validationErrors={cityValidation.messages}
                    testId="employerInformationForm__employerCity__field" />
                  }

                  <div className={styles.responsiveRow}>
                    <TextFormField
                      name="employerState"
                      label="state"
                      className={styles.FormFieldInSection}
                      placeholder="State"
                      maxLength={35}
                      value={data.employerState || ''}
                      validations={stateValidation.rules}
                      validationErrors={stateValidation.messages}
                      testId="employerInformationForm__employerState__field" />
                    {isMobile &&
                    <TextFormField
                      name="employerPostalCode"
                      label="Zipcode"
                      className={mobileZipStyles}
                      placeholder="Zipcode"
                      maxLength={20}
                      value={data.employerPostalCode || ''}
                      validations={postalCodeValidation.rules}
                      validationErrors={postalCodeValidation.messages}
                      testId="employerInformationForm__employerPostalCode__field" />
                    }
                  </div>
                  <TextFormField
                    name="employerCountry"
                    label="country"
                    className={styles.FormFieldInSection}
                    placeholder="United States"
                    maxLength={35}
                    value={data.employerCountry || 'United States'}
                    testId="employerInformationForm__employerCountry__field" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.phoneNumberSection}>
          <div className={styles.formInput}>
            <p className={styles.heading}>phone number</p>
            <MaskedFormField
              name="employerPhone"
              label="Employer Phone"
              className={styles.FormFieldInSection}
              placeholder="555-666-7777"
              mask="phoneNumber"
              value={data.employerPhone || ''}
              validations={phoneNumberValidation.rules}
              validationErrors={phoneNumberValidation.messages}
              testId="employerInformationForm__employerPhone__field" />
          </div>
        </div>

        <div className={styles.customFormSection}>
          <div className={styles.formInput}>
            <p className={styles.heading}>income tax year end</p>
            <MaskedFormField
              name="employerIncomeTaxDate"
              label="Income Tax Year"
              className={styles.smallInput}
              placeholder="MM/DD"
              mask={INCOME_TAX_DATE}
              length={5}
              value={this.renderIncomeTax()}
              validations={employerIncomeTaxDate.rules}
              validationErrors={employerIncomeTaxDate.messages}
              testId="employerInformationForm__incomeTax__field" />
          </div>
        </div>

        <div className={styles.employerIdformSection}>
          <div className={styles.formInput}>
            <p className={styles.heading}>Employer ID number (ein)</p>
            <TextFormField
              name="employerIdentificationNumber"
              label="Employer Identification Number"
              className={styles.FormFieldInSection}
              placeholder="12-3456789"
              maxLength={32}
              validations={employerIdNumberValidation.rules}
              validationErrors={employerIdNumberValidation.messages}
              value={data.employerIdentificationNumber || ''}
              testId="employerInformationForm__employerIdentificationNumber__field" />
          </div>

          {isAmendment &&
          <Fragment>
            <p className={styles.employerHeading}>effective dates</p>
            <p className={styles.employerSubheading}>
               Because this is an amendment to your existing {subType},
               we’ll need to know the date your current plan became effective,
               as well as the date the amended plan will take effect.
            </p>
            <p className={styles.employerSubheading}>
                Note: The amended plan usually takes effect on the first day of
                the plan year in which this adoption agreement is signed.
            </p>
            <div className={styles.mediumCustomFormSection}>
              <p className={styles.heading}>Existing Plan Effective Date</p>
              <div className={styles.formInput}>
                <div className={styles.container}>
                  <MaskedFormField
                    name="employerPriorPlanEffectiveDate"
                    className={styles.FormFieldInSection}
                    placeholder="MM/DD/YYYY"
                    mask={DATE}
                    validations={dateValidation.rules}
                    validationErrors={dateValidation.messages}
                    value={normalizeEffectiveDate(data.employerPriorPlanEffectiveDate) || ''}
                    testId="employerInformationForm__employerPriorPlanEffectiveDate__field" />
                </div>
              </div>
            </div>
            { !this.getEffectiveDateYearOnly() &&
            <div className={styles.actionFormSection}>
              <p className={styles.heading}>Amended Plan Effective Date</p>
              <div className={styles.formInput}>
                <div className={styles.container}>
                  <MaskedFormField
                    name="employerPlanEffectiveDate"
                    className={styles.FormFieldInSection}
                    placeholder="MM/DD/YYYY"
                    mask={DATE}
                    validations={dateValidation.rules}
                    validationErrors={dateValidation.messages}
                    value={normalizeEffectiveDate(data.employerPlanEffectiveDate) || ''}
                    testId="employerInformationForm__employerPlanEffectiveDate__field" />
                </div>
              </div>
            </div>
            }

            { this.getEffectiveDateYearOnly() &&
            <div className={styles.actionFormSection}>
              <p className={styles.heading}>Amended Plan Effective Date</p>
              <div className={effectiveDatesColumns}>
                <div className={styles.container}>
                  <TextFormField
                    name="effectiveMonth"
                    className={styles.smallInput}
                    placeholder="MM"
                    mask="date"
                    maxLength={2}
                    value="01"
                    readOnly={true}
                    testId="employerInformationForm__effectiveMonth__field" />
                </div>
                <div className={styles.container}>
                  <TextFormField
                    name="effectiveDate"
                    className={styles.smallInput}
                    placeholder="DD"
                    mask="date"
                    maxLength={2}
                    value="01"
                    readOnly={true}
                    testId="employerInformationForm__effectiveDate__field" />
                </div>
                <div className={styles.container}>
                  <MaskedFormField
                    name="employerPlanEffectiveDate"
                    className={styles.yearInput}
                    placeholder="YYYY"
                    mask={YEAR}
                    maxLength={4}
                    validations={yearValidation.rules}
                    validationErrors={yearValidation.messages}
                    value={this.renderExistingEffectiveDate()}
                    testId="employerInformationForm__employerPlanEffectiveDate__field" />
                </div>
              </div>
            </div>
            }
          </Fragment>
          }

        </div>

        {
          isIndividual401k &&
          <Fragment>
            <div className={styles.actionFormSection}>
              <p className={styles.heading}>What is your employer’s type of business? </p>
              <div className={styles.formInput}>
                <div className={styles.container}>
                  <SelectDropdownFormField
                    name="employerTypeOfBusiness"
                    placeholder="Select type"
                    label="employerTypeOfBusiness"
                    className="dropdown"
                    options={typesOfBusiness}
                    value={data.employerTypeOfBusiness}
                    required={true} />
                </div>
              </div>
            </div>
            <div className={styles.actionFormSection}>
              <p className={styles.heading}>What is the name of the employer plan?</p>
              <div className={styles.formInput}>
                <div className={styles.container}>
                  <TextFormField
                    name="employerPlanName"
                    label="Name"
                    className={styles.FormFieldInSection}
                    placeholder="Employer name"
                    maxLength={35}
                    value={data.employerPlanName || ''}
                    validations={employerPlanNameValidation.rules}
                    validationErrors={employerPlanNameValidation.messages}
                    testId="employerInformationForm__employerName__field"
                    required={true} />
                </div>
              </div>
            </div>
          </Fragment>
        }
        {
        /* eslint-disable react/button-has-type */
          <button
            className={primaryButtonClasses}
            type={formValid ? 'submit' : 'button'}
            data-test-id="employerInformationForm__saveAndContinue__cta"
            onClick={onClick}>
           Save and Continue
          </button>
        }
      </div>
    )
  }

}

export default compose(
  makeForm,
  withFormResponseHandler,
)(EmployerInformationForm)



// WEBPACK FOOTER //
// ./src/components/Onboarding/EmployerInformation/EmployerInformationForm.jsx